import home_page_v2 from './home_page_v2';
import personal_online_shopping_page from './personal_online_shopping_page';
import personal_online_shopping_page_v2 from './personal_online_shopping_page_v2';
import personal_offline_kiosk_page_v2 from './personal_offline_kiosk_page_v2';
import personal_qr_page_v2 from './personal_qr_page_v2';
import personal_jpworldpay_creditcard_page_v2 from './personal_jpworldpay_creditcard_page_v2';
import personal_trade_cashback_page_v2 from './personal_trade_cashback_page_v2';
import personal_send_page_v2 from './personal_send_page_v2';
import personal_receive_page_v2 from './personal_receive_page_v2';
import personal_deposit_page_v2 from './personal_deposit_page_v2';
import personal_commission_page_v2 from './personal_commission_page_v2';
import personal_wallet_page_v2 from './personal_wallet_page_v2';
import personal_account_page_v2 from './personal_account_page_v2';
import personal_jpys_page_v2 from './personal_jpys_page_v2';
import personal_sale_page_v2 from './personal_sale_page_v2';
import personal_exchange_page_v2 from './personal_exchange_page_v2';
import components from './components';
import business_start_page_v2 from './business_start_page_v2';
import business_receive_page_v2 from './business_receive_page_v2';
import business_pay_page_v2 from './business_pay_page_v2';
import business_risk_page_v2 from './business_risk_page_v2';
import business_corps_page_v2 from './business_corps_page_v2';
import business_platform_page_v2 from './business_platform_page_v2';
import business_pay_method_page_v2 from './business_pay_method_page_v2';
import business_global_page_v2 from './business_global_page_v2';
import business_asset_management_page_v2 from './business_asset_management_page_v2';
import development_main_page_v2 from './development_main_page_v2';
import business_development_page_v2 from './business_development_page_v2';

export default {
	components,
	home_page_v2,
	personal_online_shopping_page,
	personal_online_shopping_page_v2,
	personal_offline_kiosk_page_v2,
	personal_qr_page_v2,
	personal_jpworldpay_creditcard_page_v2,
	personal_trade_cashback_page_v2,
	personal_send_page_v2,
	personal_receive_page_v2,
	personal_deposit_page_v2,
	personal_commission_page_v2,
	personal_wallet_page_v2,
	personal_account_page_v2,
	personal_jpys_page_v2,
	personal_sale_page_v2,
	personal_exchange_page_v2,
	business_start_page_v2,
	business_receive_page_v2,
	business_pay_page_v2,
	business_risk_page_v2,
	business_corps_page_v2,
	business_platform_page_v2,
	business_pay_method_page_v2,
	business_global_page_v2,
	business_asset_management_page_v2,
	development_main_page_v2,
	business_development_page_v2,
};
